import { AccountInformationData } from "../component/AccountInformation/AccountInformation.data";
import { CompanyDetailsFormData } from "../component/CompanyDetails/CompanyDetails.data";
import { MembershipSubscriptionData } from "../component/MembershipSubscription/MembershipSubscription.data";

export const setFormViewOnly = (apiResponse) => {
    // AccountInformationData.formSetting.isViewOnly = true;
    CompanyDetailsFormData.formSetting.isViewOnly = true;
    MembershipSubscriptionData.formSetting.isViewOnly = true;
}